import { PreviewButton } from '@src/features/polotno/component/previewContainer'
import { Tabs } from 'antd'
import { useEffect, useState } from 'react'
import { Transition } from 'react-transition-group'
import ScenesTab from './sceneTabs/scenes'
import { observer } from 'mobx-react-lite'
import CaptionsTab from './sceneTabs/captions'
import VideoDurationSetting from '../sceneSettings/videoTrimmerSetting'
import { EditOutlined, CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons'
import {
  ArrowDown01Icon,
  ArrowUp01Icon,
  AudioBook01Icon,
  Clock01Icon,
  Message01Icon,
  TextSmallcapsIcon,
  ViewIcon,
  ViewOffSlashIcon,
} from '@src/features/polotno/component/hugeIcons/hugeIcons'
import { useGlobalContext } from '@src/context/globalContext'
import TextOverlayTab from './sceneTabs/textOverlayTab'
import TimelineTab from './sceneTabs/timeline'
import './Settings.less'
const { TabPane } = Tabs
     
const Settings = ({ store }: any) => {
  const [previewOpen, setPreviewOpen] = useState(false)
  const [activeKey, setActiveKey] = useState<string>('0')
  const [pageduration, setPageDuration] = useState(store?.activePage?.duration || 2000)

  const {
    ScriptDetails: [scriptDetails, setScriptDetails],
    ShowTextOverlay: [showTextOverlay, setShowTextOverlay],
    ActiveElementId: [activeElementId, setActiveElementId],
  } = useGlobalContext()

  useEffect(() => {
    const storeJson = store.toJSON()
    if (storeJson.pages.length > 0 && scriptDetails && scriptDetails.data[scriptDetails.data.length - 1].captions) {
      //store.setScale(0.25);
      setActiveElementId(store.activePage?.children[0].id)
      store.activePage?.children?.map((child: any, index: any) => {
        if (child.type == 'video') {
          setActiveElementId(child.id)
        }
      })
    }
  }, [store.activePage, store, scriptDetails])
  const handleTabChange = (key: string) => {
    setActiveKey(key)
  }
  const handleShowHideClick = () => {
    if (activeKey) {
      setActiveKey('0')
    } else {
      setActiveKey('0')
    }
  }

  useEffect(() => {
    setPageDuration(store?.activePage?.duration)
  }, [store?.activePage?.duration])
  // Styles for the transition
  const defaultStyle = {
    transition: `opacity 300ms ease-in-out, transform 300ms ease-in-out`,
    opacity: 0,
    transform: 'translateY(-10px)',
  }

  const transitionStyles: any = {
    entering: { opacity: 1, transform: 'translateY(0)' },
    entered: { opacity: 1, transform: 'translateY(0)' },
    exiting: { opacity: 0, transform: 'translateY(-10px)' },
    exited: { opacity: 0, transform: 'translateY(-10px)' },
  }
  const handleToggleSubtitle = (e: any) => {
    e.stopPropagation()
    if (scriptDetails.showSubtitles) {
      setScriptDetails((prevScript: { data: any }) => ({
        ...prevScript,
        showSubtitles: false
      }))
      store.pages.map((page: any) => {
        const elementID = 'captionText' + page.id
        page.set({ custom: { ...page.custom, showSubtitles: false } })
        if (store.getElementById(elementID)) {
          store.getElementById(elementID).set({
            opacity: 0,
            backgroundEnabled: false,
          })
        }
      })
    } else {
      setScriptDetails((prevScript: { data: any }) => ({
        ...prevScript,
        showSubtitles: true
      }))
      store.pages.map((page: any) => {
        const elementID = 'captionText' + page.id
        page.set({ custom: { ...page.custom, showSubtitles: true } })
        if (store.getElementById(elementID)) {
          store.getElementById(elementID).set({
            opacity: 1,
            backgroundEnabled: true,
          })
        }
      })
    }
  }
  const handleTextOverlayToggle = (status: boolean) => {
    setShowTextOverlay(status)
    store.pages.map((page: any) => {
      page.children.map((child: any) => {
        if (child.name === 'h1-notlinked') {
          const elementID = child.id
          if (store.getElementById(elementID)) {
            store.getElementById(elementID).set({
              visible: status,
              opacity: status ? 1 : 0,
            })
          }
        }
      })
    })
  }

  const pageDurationIncrementDecrement = (type: string) => {
    if (type === 'Increment') {
      // const currentPage = store.getElementById(pageID);
      store.activePage.set({
        duration: store.activePage.duration + 100,
      })
      setPageDuration(store.activePage.duration)
    } else if (type === 'Decrement') {
      if (pageduration > 500) {
        // const currentPage = store.getElementById(pageID);
        store.activePage.set({
          duration: store.activePage.duration - 100,
        })
        setPageDuration(store.activePage.duration)
      }
    }
  }

  return (
    <div className="settings-container">
      <div className="timeline-content">
        <TimelineTab store={store} />
      </div>
    </div>
  )
}

export default observer(Settings)

// export default Settings;
